export default {
  toasts: {
    success: 'Cartão de oferta resgatado com sucesso.',
    error: 'Falha ao resgatar cartão de oferta.',
  },
  title: 'Resgatar Cartão de Oferta',
  subtitle: 'Introduza o código do cartão de oferta e o valor a resgatar da conta do cliente.',
  form: {
    amount: {
      label: 'Valor a Resgatar',
    },
    code: {
      label: 'Código do Cartão de Oferta',
    },
  },
  buttons: {
    redeem: 'Resgatar',
    cancel: 'Cancelar',
  },
};
